import CrudTab from 'react/containers/pages/CrudTab';
import { fixGridAndFilterBuilder } from 'react/utils/utils';

class ServiceTimeUpdates extends CrudTab {
  static tabName = 'Monet.ServiceTimeUpdates.Tab.Title';
  namespaces = ['ServiceTimeUpdates'];

  componentDidMount() {
    this.router = new App.Routers.ServiceTimeUpdates();
    this.router.makeForm();
  }

  componentDidUpdate(prevProps) {
    const { active } = this.props;
    const isComingFromAnotherTab = active !== prevProps.active;
    if (isComingFromAnotherTab && active) {
      fixGridAndFilterBuilder();
    }
  }

}

export default ServiceTimeUpdates;
